import { FormLayout } from "src/components/form/formLayout/FormLayout"
import { RadioGroupField } from "../../../form/radio/radioGroup/RadioGroupField"
import type { VisibilityFields } from "./visibility.fields"

interface VisibilityFormProps {
	fields: VisibilityFields
}

export const VisibilityForm = ({ fields }: VisibilityFormProps) => {
	return (
		<FormLayout $width="half">
			<RadioGroupField {...fields.marketToCustomers} />
			{fields.onlineOrdering && <RadioGroupField {...fields.onlineOrdering} />}
		</FormLayout>
	)
}
